var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
    'dirty-button-small': _vm.small,
    'text-align-center': _vm.centerText,
    'stretch-width': _vm.stretch,
  },attrs:{"type":_vm.type},on:{"click":_vm.back}},[(_vm.callout === 'left')?_c('v-icon',{staticClass:"icon left",attrs:{"color":"#009677","small":""}},[_vm._v(_vm._s(_vm.icons.mdiArrowLeft))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),(_vm.callout === 'right')?_c('v-icon',{staticClass:"icon right",attrs:{"color":"#009677","small":""}},[_vm._v(_vm._s(_vm.icons.mdiArrowRight))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }